var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-upload',{staticClass:"video-uploader",attrs:{"action":"#","accept":"video/*","auto-upload":false,"show-file-list":false,"on-change":_vm.bindUploadChange,"disabled":_vm.disabled}},[_c('qm-button',{attrs:{"slot":"default","text":_vm.text,"disabled":_vm.disabled},slot:"default"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }